const { createSlice } = require("@reduxjs/toolkit");

const initialState = {
  config: {
  },
  loading: true,
  error: true
}

const configSlice = createSlice({
  name: "configSlice",
  initialState,
  reducers: {
    saveConfig: (state, action) => {
      // state.config = {...action.payload.data , apiBaseUrl : "http://localhost:5008"};
      state.config = action.payload.data
      state.loading = false;
      state.error = false;
    },
    clearConfig: (state) => {
      state = initialState
    },
  },
});

export const { saveConfig, clearConfig } = configSlice.actions;
export default configSlice.reducer;

